import { Gnb } from '@services/MarppleShop/renderApp/components/cells/Header/libs/types/header';
import { CategoryLevel1_CODE } from '../../../../../../../../shared/mps-shared/domain/category/types.ts';
import {
  createBuilderByCateRootCode,
  createGoodsUrlBuilder,
} from '@services/MarppleShop/features/ProductList/util';

interface GnbData {
  code: string;
  name: string;
  bottom_tab_bar_name?: string;
  url: string;
}

const RECOMMEND: GnbData = {
  code: 'RECOMMEND',
  name: 'mps2::gnb::menu::recommend',
  get url() {
    return `/${ET.lang}`;
  },
} as const;

const REALTIME: GnbData = {
  code: 'REALTIME',
  name: 'mps2::gnb::menu::real_ranking',
  bottom_tab_bar_name: 'mps2::gnb::menu::real_ranking_bottom',
  get url() {
    return createGoodsUrlBuilder().setPage('LATEST_SOLD').build();
  },
} as const;

const GOODS: GnbData = {
  code: CategoryLevel1_CODE.GOODS,
  name: 'mps2::gnb::menu::goods',
  get url(): string {
    return createBuilderByCateRootCode(CategoryLevel1_CODE.GOODS).build();
  },
} as const;

const HANDMADE: GnbData = {
  code: CategoryLevel1_CODE.HANDMADE,
  name: 'mps2::gnb::menu::handmade',
  get url(): string {
    return createBuilderByCateRootCode(CategoryLevel1_CODE.HANDMADE).build();
  },
} as const;

const BRAND_DEAL: GnbData = {
  code: CategoryLevel1_CODE.BRAND_DEAL,
  name: 'mps2::gnb::menu::brand_deal',
  get url(): string {
    return createBuilderByCateRootCode(CategoryLevel1_CODE.BRAND_DEAL).build();
  },
} as const;

const EBOOK: GnbData = {
  code: CategoryLevel1_CODE.EBOOK,
  name: 'mps2::gnb::menu::ebook',
  get url() {
    return createBuilderByCateRootCode(CategoryLevel1_CODE.EBOOK).build();
  },
} as const;

const POPUP: GnbData = {
  code: 'POPUP',
  name: 'mps2::gnb::menu::popup',
  get url() {
    return `/${ET.lang}/@/popup-store`;
  },
} as const;

const EXPLORE: GnbData = {
  code: 'EXPLORE',
  name: 'mps2::gnb::menu::explore',
  get url() {
    return `/${ET.lang}/@/creator/explore`;
  },
} as const;

const GnbDatas = [REALTIME, GOODS, HANDMADE, BRAND_DEAL, EBOOK, POPUP, EXPLORE];
const EnJpGnbDatas = [REALTIME, GOODS, POPUP, EXPLORE];
export type GNBCode = (typeof GnbDatas)[number]['code'];

export const GNB_MAP = {
  RECOMMEND,
  REALTIME,
  GOODS,
  HANDMADE,
  BRAND_DEAL,
  EBOOK,
  POPUP,
  EXPLORE,
};

export const getMenuPc = (selected_menu?: GNBCode): Gnb[] => {
  return (ET.lang === 'kr' ? GnbDatas : EnJpGnbDatas).map((gnb) => {
    const lower_code = gnb.code.toLowerCase();
    return {
      code: gnb.code,
      name: ET(gnb.name),
      url: gnb.url,
      is_selected: selected_menu?.toLowerCase() === lower_code,
    };
  });
};

export const getCateRootMenuMo = (selected_menu?: GNBCode): Gnb[] => {
  return (ET.lang === 'kr' ? [GOODS, HANDMADE, BRAND_DEAL, EBOOK] : [RECOMMEND, GOODS]).map((gnb) => {
    const lower_code = gnb.code.toLowerCase();
    return {
      code: gnb.code,
      name: ET(gnb.name),
      url: gnb.url,
      is_selected: selected_menu?.toLowerCase() === lower_code,
    };
  });
};
